import Axios from 'axios';
var ApplicationOrderService = (function () {
    function ApplicationOrderService() {
    }
    ApplicationOrderService.prototype.getList = function (params) {
        return Axios.get('supplierclientapi/application_order/list', { params: params });
    };
    ApplicationOrderService.prototype.audit = function (params) {
        return Axios.post('supplierclientapi/application_order/audit', params);
    };
    ApplicationOrderService.prototype.discard = function (params) {
        return Axios.post('supplierclientapi/application_order/cancel', params);
    };
    ApplicationOrderService.prototype.getTypeOptionList = function (params) {
        return Axios.get('supplierclientapi/application_order_type/options_list', { params: params });
    };
    ApplicationOrderService.prototype.getTypeList = function (params) {
        return Axios.get('supplierclientapi/application_order_type/list', { params: params });
    };
    ApplicationOrderService.prototype.createType = function (params) {
        return Axios.post('supplierclientapi/application_order_type/create', params);
    };
    ApplicationOrderService.prototype.updateType = function (params) {
        return Axios.post('supplierclientapi/application_order_type/update', params);
    };
    ApplicationOrderService.prototype.deleteType = function (params) {
        return Axios.post('supplierclientapi/application_order_type/delete', params);
    };
    ApplicationOrderService.prototype.getDetail = function (params) {
        return Axios.get('supplierclientapi/application_order/detail', { params: params });
    };
    ApplicationOrderService.prototype.create = function (params) {
        return Axios.post('supplierclientapi/application_order/create', params);
    };
    ApplicationOrderService.prototype.update = function (params) {
        return Axios.post('supplierclientapi/application_order/update', params);
    };
    ApplicationOrderService.createInstance = function () {
        ApplicationOrderService.getInstance();
    };
    ApplicationOrderService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return ApplicationOrderService;
}());
export default ApplicationOrderService;
